<template>
  <div class="container-principal">
    <div class="container-header-campos">
        <h2 class="texto-titulo">Basta preencher os campos <br> abaixo:</h2>
        <h2 class="barra-inferior"></h2>
    </div>
    <div class="container-formulario">
      <div v-if="!tipoPessoaSelecionado">
        <h2 class="texto-tipo-pessoa">Selecione o tipo de pessoa</h2>
        <v-select
            v-model="dadosGerais.tipoPessoa"
            :items="tiposPessoa"
            class="select-form-portal"
            name="tipoPessoaSelectInicio"
            @change="alterarTipoPessoa"
        />
      </div>
      <div v-else>
        <v-layout wrap align-center>
          <v-flex xs12 sm6 d-flex>
            <v-select
                label="Tipo de pessoa"
                v-model="dadosGerais.tipoPessoa"
                :items="tiposPessoa"
                class="select-form-portal campo-obrigatorio"
                name="tipoPessoaSelect"
            />
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-text-field name="Nome Completo do Representante Legal" label="Nome Completo do Representante Legal"
                          placeholder="Seu nome completo"
                          v-model="dadosGerais.nome"
                          v-validate="'required'" class="campo-obrigatorio"
                          :error-messages="errors.collect('Nome Completo do Representante Legal')"
            />
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-text-field name="CPF do Representante Legal" label="CPF do Representante Legal"
                          v-model="dadosGerais.cpf"
                          v-mask="masks.cpf"
                          v-validate="'required'" class="campo-obrigatorio"
                          :error-messages="errors.collect('CPF do Representante Legal')"
            />
          </v-flex>
          <v-flex xs12 sm6 d-flex v-if="dadosGerais.tipoPessoa === 'Pessoa Física'">
            <v-text-field
                          name="RG" label="RG"
                          v-model="dadosGerais.rg"
                          v-mask="masks.rg"
                          v-validate="{ required: dadosGerais.tipoPessoa === 'Pessoa Física' }"
                          class="campo-obrigatorio"
                          :error-messages="errors.collect('RG')"
            />
          </v-flex>
          <v-flex xs12 sm6 d-flex v-if="dadosGerais.tipoPessoa === 'Pessoa Jurídica'">
            <v-text-field
                          name="CNPJ" label="CNPJ"
                          v-model="dadosGerais.cnpj"
                          v-mask="masks.cnpj"
                          v-validate="{ required: dadosGerais.tipoPessoa === 'Pessoa Jurídica' }"
                          class="campo-obrigatorio"
                          :error-messages="errors.collect('CNPJ')"
            />
          </v-flex>
          <v-flex xs12 sm6 d-flex v-if="dadosGerais.tipoPessoa === 'Pessoa Jurídica'">
            <v-text-field name="Razão Social" label="Razão Social"
                          v-model="dadosGerais.razaoSocial"
                          placeholder="Nome da sua empresa"
                          v-validate="{ required: dadosGerais.tipoPessoa === 'Pessoa Jurídica' }"
                          class="campo-obrigatorio"
                          :error-messages="errors.collect('Razão Social')"
            />
          </v-flex>
          <v-flex xs12 sm6 d-flex v-if="dadosGerais.tipoPessoa === 'Pessoa Jurídica'">
            <v-text-field name="Nome Fantasia" label="Nome Fantasia"
                          v-model="dadosGerais.nomeFantasia"
                          placeholder="Nome fantasia da sua empresa"
                          v-validate="{ required: dadosGerais.tipoPessoa === 'Pessoa Jurídica' }"
                          class="campo-obrigatorio"
                          :error-messages="errors.collect('Nome Fantasia')"
            />
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
                label="Natureza Jurídica"
                v-model="dadosGerais.naturezaJuridica"
                :items="naturezaJuridicaItems"
                class="select-form-portal campo-obrigatorio"
                name="naturezaJuridicaSelect"
            />
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
                label="Porte da Empresa"
                v-model="dadosGerais.porteEmpresa"
                :items="porteEmpresaItems"
                class="select-form-portal campo-obrigatorio"
                name="porteEmpresaSelect"
            />
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-text-field name="Inscrição Municipal" label="Inscrição Municipal"
                          v-model="dadosGerais.inscricaoMunicipal"
                          :error-messages="errors.collect('Inscrição Municipal')"
            />
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-text-field name="Inscrição Estadual" label="Inscrição Estadual"
                          v-model="dadosGerais.inscricaoEstadual"
                          :error-messages="errors.collect('Inscrição Estadual')"
            />
          </v-flex>
        </v-layout>
        <h2 class="texto-formulario">Dados de Contato</h2>
        <v-layout wrap align-center>
          <v-flex xs12 sm6 d-flex>
          <v-text-field name="E-mail" label="E-mail"
                        v-model="dadosGerais.email"
                        class="campo-obrigatorio"
                        placeholder="Seu e-mail"
                        v-validate="{ required: true, email: true }"
                        :error-messages="errors.collect('E-mail')"
          />
          </v-flex>
          <v-flex xs12 sm6 d-flex>
          <v-text-field name="Telefone" label="Telefone"
                        v-model="dadosGerais.telefone"
                        class="campo-obrigatorio"
                        placeholder="Seu telefone de contato"
                        v-validate="'required'"
                        v-mask="[masks.tel1, masks.tel2]"
                        :error-messages="errors.collect('Telefone')"
          />
          </v-flex>
          <v-flex xs12 sm6 d-flex>
          <v-text-field name="CEP" label="CEP"
                        v-model="dadosGerais.cep"
                        class="campo-obrigatorio"
                        placeholder="Seu CEP"
                        v-validate="'required'"
                        v-mask="masks.cep"
                        :error-messages="errors.collect('CEP')"
          />
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-text-field name="Bairro" label="Bairro"
                          v-model="dadosGerais.bairro"
                          class="campo-obrigatorio"
                          placeholder="Seu bairro"
                          v-validate="'required'"
                          :error-messages="errors.collect('Bairro')"
            />
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-text-field name="Endereço" label="Endereço"
                          v-model="dadosGerais.endereco"
                          class="campo-obrigatorio"
                          placeholder="Seu endereço"
                          v-validate="'required'"
                          :error-messages="errors.collect('Endereço')"
            />
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-text-field name="Número" label="Número"
                          v-model="dadosGerais.numero"
                          class="campo-obrigatorio"
                          placeholder="Seu número"
                          v-validate="'required'"
                          :error-messages="errors.collect('Número')"
            />
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
                label="Estado"
                v-model="dadosGerais.estado"
                :items="estadoItems"
                class="select-form-portal campo-obrigatorio"
                name="estadoSelect"
            />
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
                label="Cidade"
                v-model="dadosGerais.cidade"
                :items="cidadeItems"
                class="select-form-portal campo-obrigatorio"
                name="cidadeSelect"
            />
          </v-flex>
        </v-layout>
        <h2 class="texto-formulario">Dados Pessoais</h2>
        <v-layout wrap align-center>
          <v-flex xs12 sm12 d-flex>
            <v-text-field name="usuário" label="Usuário (E-mail)"
                          v-model="dadosGerais.usuario"
                          placeholder="Seu e-mail"
                          class="campo-obrigatorio"
                          v-validate="{ required: true, email: true }"
                          :error-messages="errors.collect('usuário')"
            />
          </v-flex>
          <v-flex xs12 sm12 d-flex>
            <v-text-field name="Linhas de Fornecimento" label="Linhas de Fornecimento"
                          v-model="dadosGerais.linhasFornecimento"
                          placeholder="Seu e-mail"
                          class="campo-obrigatorio"
                          v-validate="{ required: true, email: true }"
                          :error-messages="errors.collect('Linhas de Fornecimento')"
            />
            <v-autocomplete
                v-model="dadosGerais.linhasFornecimento"
                name="Linhas de Fornecimento"
                placeholder="Digite para iniciar uma pesquisa (pode-se escolher mais de uma)"
                :items="linhasFornecimentoItems"
                item-text="nome"
                item-value="id"
                :filter="filtroComboAutoCompleteLinhasFornecimento"
                v-validate="{required: true}"
                :error-messages="errors.collect('Linhas de Fornecimento')">
              <template v-slot:label>
                Linhas de Fornecimento
                <a href="https://comprasbr.com.br/wp-content/uploads/2019/01/Tabela-de-Linhas-de-Fornecimento.pdf" target="_blank">(Table completa)</a>
              </template>
            </v-autocomplete>
          </v-flex>
          <div class="container-cadastro-continuar">
            <div class="container-regulamento">
              <label>Li e estou de acordo com o
                <a href="https://comprasbr.com.br/wp-content/uploads/2021/02/REGULAMENTO-Portal-de-Compras-BR.docx.pdf" target="_blank">Regulamento</a>
              </label>
            </div>
            <v-btn color="success" :depressed=true @click="cadastrarUsuario">Continuar</v-btn>
          </div>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CadastroUsuarioLicitacao',
  data(){
    return{
      itens:[],
      dadosGerais:{
        tipoPessoa: null,
        nome: null,
        cpf: null,
        rg: null,
        cnpj: null,
        razaoSocial: null,
        nomeFantasia: null,
        naturezaJuridica: null,
        porteEmpresa: null,
        inscricaoMunicipal: null,
        inscricaoEstadual: null,
        email: null,
        telefone: null,
        cep: null,
        bairro: null,
        endereco: null,
        numero: null,
        estado: null,
        cidade: null,
        usuario: null,
        linhasFornecimento: null,
      },
      tiposPessoa: ['Pessoa Física', 'Pessoa Jurídica'],
      tipoPessoaSelecionado: false,
      naturezaJuridicaItems: [],
      porteEmpresaItems: [],
      estadoItems: [],
      cidadeItems: [],
      linhasFornecimentoItems: [],
      masks: {
        cpf: '###.###.###-##',
        cnpj: '##.###.###/####-##',
        rg: '###.###.###',
        cep: '##.###-###',
        tel1: '(##) ####-####',
        tel2: '(##) #####-####'
      },
    }
  },
  methods:{
    alterarTipoPessoa(){
      if(!this.tipoPessoaSelecionado)
        this.tipoPessoaSelecionado = true
    },
    filtroComboAutoCompleteLinhasFornecimento(item, queryText) {
      const text = item.nome.toLowerCase()
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    cadastrarUsuario(){
      console.log('---cadastrarUsuario')
      console.log(this.dadosGerais)
    }
  }
}
</script>

<style scoped lang="stylus">

.container-principal
  display flex
  flex-direction column
  align-items center

.container-header-campos
  display flex
  flex-direction column
  align-items center

.texto-titulo
  font-weight 600
  font-size 42px
  color #58954C
  text-align center
  line-height normal

.barra-inferior
  background #F4B310
  height 5px
  width 100px
  content ""

.container-formulario
  margin-top 30px

.texto-tipo-pessoa
  font-weight 600
  font-size 22px
  color #58954C
  text-align center
  line-height normal

.select-form-portal
  margin 0 !important
  padding-top 0 !important
  .v-select__selections
    color #777 !important

.campo-obrigatorio label:after
    content " *"
    color rgb(255, 98, 98)

.texto-formulario
    color #1577AA
    font-size 18px
    font-weight 600

</style>